import React, {Fragment} from 'react';
import './icon-label.scss';

const IconLabel = ({ title, description, svg }) => (
	<div className="col-xs-12 col-md-11 item center-xs start-md">
		<div className="container">
			<div className="row item-row">
				<div className="col-xs-12 center-xs center-md icon">
					{svg && <Fragment>{svg}</Fragment>}
				</div>
				{title && (
					<div className="col-xs-12 center-xs center-md title">
						<p className="label">{title}</p>
					</div>
				)}
				<div className="col-xs-10 col-md-12 center-xs center-md description">
					<p className="label-description">{description}</p>
				</div>
			</div>
		</div>
	</div>
);

export default IconLabel;